const defaultIsDisabledCollapse = false;

export function isDisabledCollapse() {
  // @ts-ignore
  return window.__CC_DisableCollapse ?? defaultIsDisabledCollapse;
}
